export default __webpack_public_path__ + "static/media/cart.07fa2888.svg";